// Privacy importi: solo mascheramento visivo, nessun effetto su dati, API o calcoli.
import { useEffect, useState } from "react";

const KEY = "pv_hide_amounts";
const EVT = "pv-privacy-change";

export const isPrivacy = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
};

export const setPrivacy = (on) => {
  try { sessionStorage.setItem(KEY, on ? "1" : "0"); } catch { /* storage non disponibile */ }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVT));
};

export const togglePrivacy = () => setPrivacy(!isPrivacy());

export const usePrivacy = () => {
  const [on, setOn] = useState(isPrivacy());
  useEffect(() => {
    const h = () => setOn(isPrivacy());
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return on;
};

export const maskAmount = (formatted) => {
  const digits = String(formatted ?? "").replace(/[^\d]/g, "").length || 4;
  return `${"•".repeat(Math.min(Math.max(digits, 4), 8))} €`;
};
